module.exports = __webpack_public_path__ + "img/shouhui@3x.91e4e73c.png";